/* eslint-disable max-len */
module.exports.controlData = () => {
  return [
    {
      title: 'ADMINISTRATIVE SAFEGUARDS',
      data: [
        {
          rule: '164.308(a)(1)(ii)(D)',
          question: 'Does your practice have policies and procedures for the review of information system activity?',
          assignedTo: 'Melbourne James',
          complianceDate: '12/01/2009',
          evidence: ['test', 'test']
        },
        {
          rule: '164.308(a)(1)(ii)(E)',
          question: 'Does your practice formally document a security plan?',
          assignedTo: 'Jane Morrison',
          complianceDate: '02/01/2011',
          evidence: []
        },
        {
          rule: '164.308(a)(1)(ii)(F)',
          question: 'Does your practice formally document a security policy?',
          assignedTo: 'Jane Morrison',
          complianceDate: '02/01/2003',
          evidence: []
        }
      ]
    },
    {
      title: 'TECHNICAL SAFEGUARDS',
      data: [
        {
          rule: '164.308(a)(1)(ii)(D)',
          question: 'Does your practice have policies and procedures for the review of information system activity?',
          assignedTo: 'Melbourne James',
          complianceDate: '12/01/2009',
          evidence: ['test', 'test']
        },
        {
          rule: '164.308(a)(1)(ii)(E)',
          question: 'Does your practice formally document a security plan?',
          assignedTo: 'Jane Morrison',
          complianceDate: '02/01/2011',
          evidence: []
        },
        {
          rule: '164.308(a)(1)(ii)(F)',
          question: 'Does your practice formally document a security policy?',
          assignedTo: 'Jane Morrison',
          complianceDate: '02/01/2003',
          evidence: []
        }
      ]
    }
  ]
}

module.exports.adviceData = () => {
  return [
    {
      adTitle: 'Things to Consider',
      consider: {
        data: [
          {
            base: 'Consider that information system activity reviews enable your practice to detect and investigate irregular system use that can indicate a violation of security policies and a privacy breach.'
          },
          {
            base: 'Consider whether your practice:',
            sub: [
              'Analyzes its activity and incident reports',
              'Analyzes its audit reviews'
            ]
          }

        ]
      }
    },
    {
      adTitle: 'Threats',
      consider: {
        data: [
          {
            base: 'Your practice may not be able to detect and prevent security violations and privacy breaches related to ePHI if it does not review system activity information as part of its continuous, day-to-day operations.'
          },
          {
            base: 'Some potential impacts include:',
            sub: [
              'Unauthorized or excessive access to ePHI by individuals can compromise the confidentiality, integrity, and availability of your practice’s ePHI.',
              'Unauthorized disclosure, loss, or theft of ePHI can lead to medical identity theft.',
              'Accurate ePHI may not be available when needed, which can adversely impact your healthcare professionals’ ability to diagnose and treat their patients.'
            ]
          }

        ]
      }
    }
  ]
}

module.exports.assessmentCategories = () => {
  return {
    data: [
      {
        index: 1,
        category: 'Company Details'
      },
      {
        index: 2,
        category: 'Company Data'
      },
      {
        index: 3,
        category: 'Company Compliance'
      },
      {
        index: 4,
        category: 'Company Security Awareness'
      },
      {
        index: 5,
        category: 'Company Risk'
      }
    ]
  }
}

module.exports.companyProfileAssessmentData = () => {
  return {
    progress: 1,
    data: [
      {
        id: 1,
        question: 'Company Name',
        helpText: "If you're not ready to share you company name, pick a code name.",
        category: 'Company Details',
        questionType: 'text',
        answers: [''],
        selectedAnswer: ''
      },
      {
        id: '3',
        question: 'Number of Employees & Independent Contractors',
        helpText: null,
        category: 'Company Details',
        questionType: 'checkbox',
        answers: ['Self-employed', '1-10 employees', '11-50 employees'],
        selectedAnswer: ''
      },
      {
        id: '11',
        question: 'What Industry does your business operate?',
        helpText: 'Choose the closest industry in the list.',
        category: 'Company Details',
        questionType: 'radio',
        answers: ['Healthcare', 'Financial', 'Educaion', 'Technology'],
        selectedAnswer: ''
      },
      {
        id: '8',
        question: 'Number of years in business',
        helpText: null,
        category: 'Company Details',
        questionType: 'dropdown',
        answers: ['Less than a year', '1-5 years', '5-10years'],
        selectedAnswer: ''
      },
      {
        id: '16',
        question: "What are your organization's business goals for the next 12 months?",
        helpText: null,
        category: 'Company Details',
        questionType: 'multiselect',
        answers: ['Increase revenue', 'Balance budget', 'Improve customer service', 'Manage cost'],
        selectedAnswer: ''
      },
      {
        id: '18',
        question: 'Company Logo',
        helpText: "Attach now or later, we'll include your logo on you policy and training documents.",
        category: 'Company Details',
        questionType: 'upload',
        answers: [''],
        selectedAnswer: ''
      },
      {
        id: '16',
        question: 'Does your organization collect or handle of the following information for your employees, customers, or partners:',
        helpText: 'Select all that you know of now. There will be time to come back and add more later.',
        category: 'Data',
        questionType: 'checkbox',
        answers: [
          'Names',
          'SSNs or Tax ID Numbers',
          'Email Addresses',
          'Unlisted phone numbers',
          'Cookies',
          'Cultural or demographic information',
          'IP Addresses',
          'Social Media Posts',
          'Any personal data of children under 16',
          'Financial records',
          'Medical History',
          'Payment Card data',
          'Lab or test results',
          'Insurance information',
          'Not Sure',
          'Other',
          'None'
        ],
        selectedAnswer: ''
      },
      {
        id: '16',
        question: 'Does your organization have intellectual property?',
        helpText: null,
        category: 'Data',
        questionType: 'radio',
        answers: ['Yes', 'No'],
        selectedAnswer: ''
      },
      {
        id: '16',
        question: 'Select all that apply:',
        helpText: null,
        category: 'Compliance',
        questionType: 'checkbox',
        answers: [
          'Your organization process credit cards',
          'Your customers include government agencies',
          'Publicly traded company'
        ],
        selectedAnswer: ''
      },
      {
        id: '16',
        question: 'Select the policies/plans at your organization:',
        helpText: null,
        category: 'Security Awareness',
        questionType: 'checkbox',
        answers: [
          'Information Security',
          'Computer Usage/Acceptable Use',
          'Privacy',
          'Data Classification',
          'Incident Response',
          'Disaster Recovery Plan',
          'Business Continuity Plan',
          'Encryption',
          'Access Control Policy',
          'Media Protection'
        ],
        selectedAnswer: ''
      },
      {
        id: '16',
        question: 'What is your budget for security',
        helpText: 'This helps us suggest solutions and strategies within your budget. This should include solutions, services, training, and people (employees, contractors, or specialized consultants)',
        category: 'Risk',
        questionType: 'range',
        answers: ['Increase revenue', 'Balance budget', 'Improve customer service', 'Manage cost'],
        selectedAnswer: ''
      },
      {
        id: '16',
        question: 'Third-Party Vendors, Contractors, and Partners have the following:',
        helpText: null,
        category: 'Access Management',
        questionType: 'radio',
        answers: [
          'Access to your data',
          'Access to your network',
          "I don't know, No Access"
        ],
        selectedAnswer: ''
      }
    ]
  }
}

module.exports.privacyPolicyData = () => {
  return {
    websitename: 'Test',
    url: 'test@test.com',
    personalinfo: ['Email address', 'First and last name', 'Phone number', 'Address, State, Province, ZIP/Postal code, City'],
    country: 'Jamaica',
    date: 'July 25, 2018'
  }
}

module.exports.trialExpiresOn = '9/15/2018'
module.exports.lastLoginAt = '8/15/2018'
module.exports.profileID = 1
module.exports.stripeCustomerId = 'cus_Ddmh8TA9KMVFIQ'

module.exports.memberAssignments = () => {
  return [
    {
      name: 'Carl Nelson',
      assignCount: 3
    },
    {
      name: 'Macy Lee',
      assignCount: 5
    },
    {
      name: 'Floyd Johnson',
      assignCount: 1
    },
    {
      name: 'Brianne Boore',
      assignCount: 2
    },
    {
      name: 'Carlos Brown',
      assignCount: 3
    },
    {
      name: 'Karl Lee',
      assignCount: 3
    }
  ]
}

module.exports.profileData = {
  name: 'Lora Kolly',
  postion: 'Human Resource',
  email: 'lkolly@yourcompany.com',
  phone: '415-555-1212'
}

module.exports.postureReport = () => {
  return [
    {
      title: 'Compliance',
      img: 'security-icon.png',
      data: [
        {
          body: 'GDPR (100% Compliant)'
        },
        {
          body: 'HIPAA (70% COmpliant)'
        },
        {
          body: 'PCI (Not Started)'
        }
      ]
    },
    {
      title: 'Policies',
      img: 'policies.png',
      data: [
        {
          body: 'Privacy Policy (100% Completed, Reviewed by Team)'
        },
        {
          body: 'Email Policy (100% Completed, 70% Reviewed by Team)'
        },
        {
          body: 'Password Policy (0% Completed)'
        }
      ]
    },
    {
      title: 'Internal Training',
      img: 'internal-training.png',
      data: [
        {
          body: 'Phishing 101 (90% Reviewed by Team)'
        }
      ]
    },
    {
      title: 'Data Management',
      img: 'DataManagement.png',
      data: [
        {
          body: 'Data Loss Risk is Low'
        },
        {
          body: 'No IOT Device on Network'
        }
      ]
    }
  ]
}

module.exports.hipaaPlaybook = () => {
  return [
    {
      title: 'Appoint a HIPAA Compliance Officer',
      rules: [
        {
          title: 'Appoint a HIPAA Compliance Officer',
          description: 'The HIPAA Compliance Officer is responsible for leading the development, implementation, maintenance, and adherence to the security and privacy policies and procedures required for HIPAA compliance. It is important that this individual has enough familiarity with HIPAA compliance requirements to provide needed oversight and leadership of the compliance program.  (COMPLETED BY PEAR SPORTS)',
          due: 1
        }
      ]
    },
    {
      title: 'Conduct a Security Risk Assessment',
      description: 'Conduct a thorough assessment of the potential risks and vulnerabilities to the confidentiality, integrity, and availability of ePHI held by the covered entity. A security risk analysis is the foundation upon which to build the security activities to protect ePHI.',
      rules: [
        {
          title: 'Compile Asset Inventory List',
          description: 'Collect the following information for each hardware assets: Software Versions, Host Name, Status, System Environment, System Dependencies (e.g. this system is dependent on), Dependency Change Impact Analysis (those dependent on this system),  Supported Programs/Applications, Supported Programs/Applications Function, Interfaces, Interface Function(s), Security Measures, User Name(s) & Title(s), Access Level, Category/ Responsibilities/Role, Provider stakeholder',
          checked: true,
          due: 30,
          controls: '164.308(a)(1)(ii)(A)'
        },
        {
          title: 'Compile ePHI Data Inventory List',
          description: 'Lack of an assessment increases the likelihood that critical ePHI will not be appropriately available during and after an emergency or breach. \\\n1) Create a data inventory list (which may include more than what is stored/transmitted in key ePHI applications). Data may be in many locations, such as Microsoft Word, Excel & Outlook and other information systems/software applications used to support your business functions, on removable media (e.g. flash drives, backup drives, etc.), portable/mobile devices, authorized personal devices, remote access device (e.g. air card, Wi-Fi or cellular dongle), etc. \\n2) Assign criticalities to them. \\n3) Assign a business owner/custodian for each ePHI application, information system, asset type, etc. \\n4) Assign an individual to maintain the inventory. \\n5) Maintain the list in a secure location and limit access to the minimum necessary.',
          due: 30,
          controls: '164.308a7iiE'
        },
        {
          title: 'Compile a list of all business associates and vendors.',
          description: 'Covered Entities and Business Associates are required to obtain satisfactory assurances that their Business Associate/Vendors will appropriately safeguard the ePHI.',
          checked: true,
          due: 30,
          controls: '164.308(a)(1)(i)(A)'
        },
        {
          title: 'Compile Threat Sources and Vulnerability List',
          description: 'Unidentified/unknown vulnerabilities present an increased risk to patient data and the systems that store and process it. Risks include any threat source that may impact the confidentiality, integrity, and/or availability of patient data. Identify potential threats and vulnerabilities and rank them based on their likelihood and impact should they happen (to prevent them from happening).',
          due: 30,
          controls: '164.308(a)(1)(ii)(A),164.308(a)(1)(ii)(B)'
        },
        {
          title: 'Hire professional risk assessor to complete assessment',
          description: 'HIPAA requires a qualified security risk assessor to perform an analysis of the administrative, physical and technical risks to ePHI. This assessment will include a technical assessment of IT systems that access, store and transmits ePHI. The assessment might also include a penetration test. Complete the pre-work to reduce time and cost.',
          due: 30,
          controls: '164.308(a)(1)'
        }
      ]
    },
  ]
}

module.exports.getSubModules = () => {
  return [
    {
      isActive: true,
      name: 'SECURITY',
      displayName: 'Security',
      _typename: 'SubModules'
    },
    {
      isActive: true,
      name: 'HIPAA',
      displayName: 'HIPAA',
      _typename: 'SubModules'
    },
    {
      isActive: true,
      name: 'PCI',
      displayName: 'PCI',
      __typename: 'SubModules'
    }
  ]
}

module.exports.getTrainingByUser = () => {
  return [
    {
      completedMonthlyQuizzes: [],
      email: 'bbird@qualityworkscg.com',
      name: 'Brittany Bird',
      quizCompleted: false,
      quizScore: 0,
      totalMonthlyQuizScore: 0,
      overallScore: 0,
      _typename: 'TrainingRecord'
    },
    {
      completedMonthlyQuizzes:[],
      email: 'bstewart@qualityworkscg.com',
      name: 'Brittany Stewart',
      quizCompleted: false,
      quizScore: 0,
      totalMonthlyQuizScore: 0,
      overallScore: 480,
      _typename: 'TrainingRecord'
    },
    {
      completedMonthlyQuizzes: [
        'August-2020',
        'December-2020',
        'February-2021'
      ],
      email: 'dscotland+qw@qualityworkscg.com',
      name: 'Doneil Scotland',
      quizCompleted: true,
      quizScore: 70,
      totalMonthlyQuizScore: 500,
      overallScore: 910,
      _typename: 'TrainingRecord'
    }
  ]
}

module.exports.complianceRecommendations = () => {
  return [
    {
      title: 'Policies',
      img: 'policies.png',
      data: [
        {
          body: 'Email Policy - This has already been generated! Ready to review? ',
          linkText: 'Click here',
          url: '/app/emailPolicy',
          checked: true
        },
        {
          body: 'Privacy Policy ',
          linkText: 'Click here to complete',
          url: '/app/privacyPolicy'
        },
        {
          body: 'Password Policy ',
          linkText: 'Click here',
          url: '/app/passwordPolicy'
        }
      ]
    },
    {
      title: 'Internal Training',
      img: 'internal-training.png',
      data: [
        {
          body: "Assign Team 'Phishing 101' ",
          linkText: 'Click here',
          url: '/app/training'
        },
        {
          body: 'Assign Team to read Email Policy ',
          linkText: 'Click here',
          url: '/app/emailPolicy'
        },
        {
          body: 'Assign Team to read Privacy Policy ',
          linkText: 'Click here',
          url: '#'
        }
      ]
    },
    {
      title: 'Next Steps',
      img: 'next-steps.png',
      data: [
        {
          body: 'Take GDPR Assessment ',
          linkText: 'Click here',
          url: '/app/gdpr'
        },
        {
          body: 'Take Data Management Assessment ',
          linkText: 'Click here',
          url: '/app/data-management'
        },
        {
          body: 'Take Device Management Assessment ',
          linkText: 'Click here',
          url: '/app/device-management'
        }
      ]
    }
  ]
}

module.exports.tourProducts = () => {
  return [
    {
      companyDescription: "Compliance.Simplified.",
      companyEmail: "posture@qualityworkscg.com",
      companyLogo: "https://vendor-data-bucket-dev.s3.amazonaws.com/Posture-PRODUCT_IMAGE_1-Posture-Marketplace-Image-2_Advisory.png",
      companyName: "Posture",
      images: ["https://vendor-data-bucket-dev.s3.amazonaws.com/Posture-PRODUCT_IMAGE_1-Posture-Marketplace-Image-2_Advisory.png"],
      price: 25000,
      productID: "sku_JbC5u7Ry0K6GLr",
      productLongDescription: "Simplify the time and hassle of creating a dozens of policies and procedures required for HIPAA Security Rule Compliance. Fill out simple questionnaires provided by Posture and we'll do the rest. Receive a policies based on industry best practices customized for your organization in days instead of months. \n\nThis package comes with one document that contains the following eight (8) policies: \n   1. Contingency Plan\n   2. Data Backup Policy\n   3. Emergency Testing Policy and Procedure\n   4. IT System Maintenance Policy\n   5. Information System Activity Review Policy\n   6. Remote Access Policy and Procedure\n   7. Mobile Devices Policy\n   8. Media Sanitization and Disposal Policy\n\nWhat you are purchasing:\n   • Automated generation of your policies (including your company logo). \n   • Policies available in less than 24 hours after completing questionnaire.",
      productName: "HIPAA IT Management and Resilience Policies",
      productShortDescription: "This package includes policies required for HIPAA Security Rule Compliance related to IT Management and Resilience. ",
      tags: ["Contingency", "HIPAA"],
      turnaroundTime: "7",
      __typename: "Product"
    },
    {
      companyDescription: "Compliance.Simplified.",
      companyEmail: "posture@qualityworkscg.com",
      companyLogo: "https://vendor-data-bucket-dev.s3.amazonaws.com/Posture-PRODUCT_IMAGE_1-Posture-Marketplace-Image-2_Advisory.png",
      companyName: "Posture",
      images: ["https://vendor-data-bucket-dev.s3.amazonaws.com/Posture-PRODUCT_IMAGE_1-Posture-Marketplace-Image-2_Advisory.png"],
      price: 25000,
      productID: "sku_JbC5kObe2QZIoU",
      productLongDescription: "Simplify the time and hassle of creating dozens of policies and procedures required for HIPAA Security Rule Compliance. Fill out a simple 3 minute questionnaire provided by Posture and we'll do the rest. Receive a policies based on industry best practices customized for your organization in days instead of months. \n\nThis package comes with one document that contains the following eight (8) policies: \n   1. HIPAA Security Program Policy and Procedures for Security Officer\n   2. Security Awareness Program Training Policy\n   3. Evaluation Policy\n   4. HIPAA Violation Sanction Policy\n   5. Termination Policy\n   6. Risk Management Process Policy\n   7. Security Incident Response Plan\n   8. HIPAA Security, Privacy and Breach Notification Policies & Procedures for PHI\n\nWhat you are purchasing:\n   • Automated generation of your policies (including your company logo). \n   • Policies available in less than 24 hours after completing questionnaire. ",
      productName: "HIPAA Security Management Policies",
      productShortDescription: "This package includes policies required for HIPAA Security Rule related to security management. ",
      tags: ["Risk Management", " HIPAA"],
      turnaroundTime: "7",
      __typename: "Product"
    },
    {
      companyDescription: "Clym LTD is a UK-based company. Clym LTD addresses companies that want ensure compliance by allowing them to manage data privacy regulations across the globe with one simple & powerful tool",
      companyEmail: "admin@cylm.io",
      companyLogo: "https://vendor-data-bucket-dev.s3.amazonaws.com/CLYM-PRODUCT_IMAGE_1-Posture-Marketplace-Image-2_Clym.png",
      companyName: "CLYM",
      images: ["https://vendor-data-bucket-dev.s3.amazonaws.com/CLYM-PRODUCT_IMAGE_1-Posture-Marketplace-Image-2_Clym.png"],
      price: 4500,
      productID: "sku_JY7DQCx1SlQNNb",
      productLongDescription: "Clym is a dynamic cookie Consent Management Platform (CMP) that will enable you to manage consents, data privacy documents and data subject requests in one place. This data privacy platform helps you meet data protection obligations across the globe so that you can control, collect and manage the data that is relevant for your company, based on users’ consent.\n\nWhat you are purchasing:\nThis package includes the basic privacy needs for website owners and allows you to manage cookies, users’ consent, data subjects’ requests, policies, agreements, procedures and more in a transparent way.\n\nFor $45 a month you get:\n   • 5 000 monthly pageviews\n   • Compliance for 1 domain\n   • Unlimited pages\n   • GDPR, LGPD and CCPA compliance\n   • No Contract, Cancel Anytime\n   • Installation Assistance : $350 (optional)\n\nIf you have more than 5000 pageviews per month, select Quantity 2 for up to 15,000 pageviews.\nSelect Quantity 3 if you have up to 50,000 pageviews.\n\n",
      productName: "Cookie Management",
      productShortDescription: "A data privacy platform for GDPR, CCPA, and LGPD that helps companies meet data protection obligation",
      tags: ["Data Privacy", "Cookies", "GDPR", "CCPA", "LGPD "],
      turnaroundTime: "2",
      __typename: "Product"
    }
  ]
}

module.exports.getTourControls = () => {
  return {
    controls: {
      items: [
        {
          advice: null,
          assetType: null,
          controlID: "1",
          controlNanoID: "Hs-krhoxi6Po",
          controlOrder: "1",
          description: "Limit information system access to authorized users, processes acting on behalf of authorized users or devices (including other information systems).",
          frameworkID: 10,
          hasSolution: null,
          helpText: null,
          highLevelCategoryNanoID: null,
          implementationName: null,
          lowLevelCategoryNanoID: "bLa07nXsqOnf",
          referenceID: "AC.1.001",
          requiredAddressable: null,
          securityFunction: null,
          solutionTags: null,
          standardOrder: null
        },
        {
          advice: null,
          assetType: null,
          controlID: "4",
          controlNanoID: "wf-jtBmWGGZ3",
          controlOrder: "2",
          description: "Limit information system access to the types of transactions and functions that authorized users are permitted to execute.",
          frameworkID: 10,
          hasSolution: null,
          helpText: null,
          highLevelCategoryNanoID: null,
          implementationName: null,
          lowLevelCategoryNanoID: "bLa07nXsqOnf",
          referenceID: "AC.1.002",
          requiredAddressable: null,
          securityFunction: null,
          solutionTags: null,
          standardOrder: null
        },
        {
          advice: null,
          assetType: null,
          controlID: "19",
          controlNanoID: "uZMJtvGAKIDH",
          controlOrder: "3",
          description: "Verify and control/limit connections to and use of external information systems.",
          frameworkID: 10,
          hasSolution: null,
          helpText: null,
          highLevelCategoryNanoID: null,
          implementationName: null,
          lowLevelCategoryNanoID: "bLa07nXsqOnf",
          referenceID: "AC.1.003",
          requiredAddressable: null,
          securityFunction: null,
          solutionTags: null,
          standardOrder: null
        },
        {
          advice: null,
          assetType: null,
          controlID: "20",
          controlNanoID: "DZe5C8R-pRd2",
          controlOrder: "4",
          description: "Control information posted or processed on publicly accessible information systems.",
          frameworkID: 10,
          hasSolution: null,
          helpText: null,
          highLevelCategoryNanoID: null,
          implementationName: null,
          lowLevelCategoryNanoID: "bLa07nXsqOnf",
          referenceID: "AC.1.004",
          requiredAddressable: null,
          securityFunction: null,
          solutionTags: null,
          standardOrder: null
        }
      ],
      nextToken: null
    }
  }
}

module.exports.getTourControlBySectionID = () => {
  return {
    tasksBySectionId: [
      {
        assignedTo: null,
        categoryId: null,
        controlId: "Hs-krhoxi6Po",
        dueDate: null,
        frameworkId: "12",
        id: "840f5d1e-c425-484e-89f2-a452b5adc932-dev:Hs-krhoxi6Po",
        referenceId: "AC.1.001",
        sectionId: "bLa07nXsqOnf",
        status: "COMPLIANT",
        tenantId: "840f5d1e-c425-484e-89f2-a452b5adc932-dev",
        updatedBy: "a647a616-7248-403c-a8cb-c45ad0e4e305"
      },
      {
        assignedTo: null,
        categoryId: null,
        controlId: "wf-jtBmWGGZ3",
        dueDate: null,
        frameworkId: "12",
        id: "840f5d1e-c425-484e-89f2-a452b5adc932-dev:wf-jtBmWGGZ3",
        referenceId: "AC.1.002",
        sectionId: "bLa07nXsqOnf",
        status: "COMPLIANT",
        tenantId: "840f5d1e-c425-484e-89f2-a452b5adc932-dev",
        updatedBy: "175b7b04-61cd-4353-b9a7-12ad6ab093ea",
      }
    ]
  }
}

module.exports.getHelpText = () => {
  return {
    
  }
}

module.exports.frameworkMapping = () => {
  return {
    '10': {
      id: 10,
      name: 'cmmc1',
      path: 'cmmc1',
      humanName: 'CMMC',
      frameworkTitle: 'CMMC Level 1',
      manageFrameworksName: 'CMMC Level 1',
      color: '#ff66ff',
      fill_color: '#ff66ff',
      description: ``,
      flat: false,
      parse: false,
      layout: 1,
      levels: true,
      enabled:null
    }
  }
}

module.exports.frameworkCategories = () => {
  return {
      categories: [
        {
          categories: null,
          controlNanoID: null,
          description: "C024 Sanitize media",
          highLevelCategoryNanoID: null,
          highLevelOrder: null,
          lowLevelCategoryNanoID: "5wLdGQir9LeG",
          name: "Media Protection (MP)",
          numberOfCompliantControls: 0,
          numberOfControls: 1,
          numberOfNotApplicableControls: 0,
          safeguardID: null,
        },
        {
          categories: null,
          controlNanoID: null,
          description: "C040 Identify and manage information system flaws",
          highLevelCategoryNanoID: null,
          highLevelOrder: null,
          lowLevelCategoryNanoID: "HVAkoeFSZ9j5",
          name: "System & Information Integrity (SI)",
          numberOfCompliantControls: 0,
          numberOfControls: 4,
          numberOfNotApplicableControls: 0,
          safeguardID: null
        },
        {
          categories: null,
          controlNanoID: null,
          description: "C015 Grant access to authenticated entities",
          highLevelCategoryNanoID: null,
          highLevelOrder: null,
          lowLevelCategoryNanoID: "Q8dkiEe02cUy",
          name: "Identification & Authentication (IA)",
          numberOfCompliantControls: 0,
          numberOfControls: 2,
          numberOfNotApplicableControls: 0,
          safeguardID: null
        },
        {
          categories: null,
          controlNanoID: null,
          description: "C028 Limit physical access",
          highLevelCategoryNanoID: null,
          highLevelOrder: null,
          lowLevelCategoryNanoID: "bEGliAqxrCEY",
          name: "Physical Protection (PE)",
          numberOfCompliantControls: 0,
          numberOfControls: 4,
          numberOfNotApplicableControls: 0,
          safeguardID: null
        },
        {
          categories: null,
          controlNanoID: null,
          description: "C001 Establish system access requirements",
          highLevelCategoryNanoID: null,
          highLevelOrder: null,
          lowLevelCategoryNanoID: "bLa07nXsqOnf",
          name: "Access Control (AC)",
          numberOfCompliantControls: 2,
          numberOfControls: 4,
          numberOfNotApplicableControls: 0,
          safeguardID: null
        },
        {
          categories: null,
          controlNanoID: null,
          description: "C039 Control communications at system boundaries",
          highLevelCategoryNanoID: null,
          highLevelOrder: null,
          lowLevelCategoryNanoID: "ydDc8RkI4N5b",
          name: "System & Communications Protection (SC)",
          numberOfCompliantControls: 0,
          numberOfControls: 2,
          numberOfNotApplicableControls: 0,
          safeguardID: null
        }
      ],
      flat: true,
      framework: "cmmc"
    
  }
}

module.exports.products = () => {
  return [
    {
      id: 1,
      src: process.env.PUBLIC_URL + '/img/for_store/catalog/advice.jpeg',
      title: '1 hr Advisor Session',
      price: 12,
      description: 'Have a one-on-one session with our inhouse security advisor',
      colors: ['#00b3c6', '#50e3c2', '#fa4a86'],
      new: true,
      tag: '1hr-advice-session',
      quantity: 1,
      category: 'advice',
      info: 'Knowledge nay estimable questions repulsive daughters boy. Solicitude gay way unaffected expression for. His mistress ladyship required off horrible disposed rejoiced. Unpleasing pianoforte unreserved as oh he unpleasant no inquietude insipidity. Advantages can discretion possession add favourable cultivated admiration far. ',
      gallery: [
        { src: process.env.PUBLIC_URL + '/img/for_store/catalog/advice.jpeg' }
      ]
    },
    {
      id: 2,
      src: process.env.PUBLIC_URL + '/img/for_store/catalog/advice.jpeg',
      title: '2 hr Advisor Session',
      price: 20,
      description: 'Have a one-on-one session with our inhouse security advisor',
      colors: ['#d4d4d4', '#5ff4d3', '#f7a9c4'],
      new: true,
      quantity: 1,
      tag: '2hr-advice-session',
      category: 'advice',
      info: 'Knowledge nay estimable questions repulsive daughters boy. Solicitude gay way unaffected expression for. His mistress ladyship required off horrible disposed rejoiced. Unpleasing pianoforte unreserved as oh he unpleasant no inquietude insipidity. Advantages can discretion possession add favourable cultivated admiration far. ',
      gallery: [
        { src: process.env.PUBLIC_URL + '/img/for_store/catalog/advice.jpeg' }
      ]
    },
    {
      id: 3,
      src: process.env.PUBLIC_URL + '/img/for_store/catalog/email.png',
      title: 'Email Policy',
      price: 3,
      description: 'Help employees use their company email addresses appropriately',
      colors: ['#fa93bd'],
      sale: true,
      quantity: 1,
      oldPrice: '8',
      tag: 'email-policy',
      category: 'policy',
      info: 'A corporate email policy is a management document that formally outlines how employees can use electronic communication tools. The policy sets guidelines for what is deemed acceptable use and unacceptable use.',
      gallery: [
        { src: process.env.PUBLIC_URL + '/img/for_store/catalog/email.png' }
      ]
    },
    {
      id: 4,
      src: process.env.PUBLIC_URL + '/img/for_store/catalog/assessment.png',
      title: 'Vendor Assessment',
      price: 28,
      description: 'Complete this new Assessment',
      new: true,
      quantity: 1,
      colors: ['#c6890a', '#faee5a'],
      tag: 'vendor-assessment',
      category: 'assessment',
      info: 'The assessment or evaluation of a prospective vendor to determine if they can effectively meet the obligations and needs of the business regarding a service or product. ',
      gallery: [
        { src: process.env.PUBLIC_URL + '/img/for_store/catalog/assess.png' }
      ]
    },
    {
      id: 5,
      src: process.env.PUBLIC_URL + '/img/for_store/catalog/assessment.png',
      title: 'GDPR Assessment',
      price: 28,
      description: 'Complete this new Assessment',
      new: true,
      quantity: 1,
      colors: ['#c6890a', '#faee5a'],
      tag: 'gdpr-assessment',
      category: 'assessment',
      info: 'The assessment or evaluation of a prospective vendor to determine if they can effectively meet the obligations and needs of the business regarding a service or product. ',
      gallery: [
        { src: process.env.PUBLIC_URL + '/img/for_store/catalog/assess.png' }
      ]
    },
    {
      id: 6,
      src: process.env.PUBLIC_URL + '/img/for_store/catalog/advice.jpeg',
      title: '3 hr Advice Session',
      price: 28,
      description: 'Complete this new Assessment',
      new: true,
      quantity: 1,
      colors: ['#c6890a', '#faee5a'],
      tag: '3hr-advice-session',
      category: 'advice',
      info: 'The assessment or evaluation of a prospective vendor to determine if they can effectively meet the obligations and needs of the business regarding a service or product. ',
      gallery: [
        { src: process.env.PUBLIC_URL + '/img/for_store/catalog/assess.png' }
      ]
    },
    {
      id: 7,
      src: process.env.PUBLIC_URL + '/img/for_store/catalog/assessment.png',
      title: 'Vendor Assessment',
      price: 28,
      description: 'Complete this new Assessment',
      sale: true,
      quantity: 1,
      colors: ['#c6890a', '#faee5a'],
      tag: 'vendor-assessment',
      category: 'assessment',
      info: 'The assessment or evaluation of a prospective vendor to determine if they can effectively meet the obligations and needs of the business regarding a service or product. ',
      gallery: [
        { src: process.env.PUBLIC_URL + '/img/for_store/catalog/assess.png' }
      ]
    },
    {
      id: 8,
      src: process.env.PUBLIC_URL + '/img/for_store/catalog/email.png',
      title: 'Vendor Assessment',
      price: 28,
      description: 'Complete this new Assessment',
      new: true,
      quantity: 1,
      colors: ['#c6890a', '#faee5a'],
      tag: 'vendor-assessment',
      category: 'assessment',
      info: 'The assessment or evaluation of a prospective vendor to determine if they can effectively meet the obligations and needs of the business regarding a service or product. ',
      gallery: [
        { src: process.env.PUBLIC_URL + '/img/for_store/catalog/assess.png' }
      ]
    },
    {
      id: 9,
      src: process.env.PUBLIC_URL + '/img/for_store/catalog/advice.jpeg',
      title: '2 hr Advisor Session',
      price: 20,
      description: 'Have a one-on-one session with our inhouse security advisor',
      colors: ['#d4d4d4', '#5ff4d3', '#f7a9c4'],
      new: true,
      quantity: 1,
      tag: '2hr-advice-session',
      category: 'advice',
      info: 'Knowledge nay estimable questions repulsive daughters boy. Solicitude gay way unaffected expression for. His mistress ladyship required off horrible disposed rejoiced. Unpleasing pianoforte unreserved as oh he unpleasant no inquietude insipidity. Advantages can discretion possession add favourable cultivated admiration far. ',
      gallery: [
        { src: process.env.PUBLIC_URL + '/img/for_store/catalog/advice.jpeg' }
      ]
    },
    {
      id: 10,
      src: process.env.PUBLIC_URL + '/img/for_store/catalog/email.png',
      title: 'Email Policy',
      price: 3,
      description: 'Help employees use their company email addresses appropriately',
      colors: ['#fa93bd'],
      sale: true,
      quantity: 1,
      oldPrice: 8,
      tag: 'email-policy',
      category: 'policy',
      info: 'A corporate email policy is a management document that formally outlines how employees can use electronic communication tools. The policy sets guidelines for what is deemed acceptable use and unacceptable use.',
      gallery: [
        { src: process.env.PUBLIC_URL + '/img/for_store/catalog/email.png' }
      ]
    },
    {
      id: 11,
      src: process.env.PUBLIC_URL + '/img/for_store/catalog/assessment.png',
      title: 'Vendor Assessment',
      price: 28,
      description: 'Complete this new Assessment',
      new: true,
      quantity: 1,
      colors: ['#c6890a', '#faee5a'],
      tag: 'vendor-assessment',
      category: 'assessment',
      info: 'The assessment or evaluation of a prospective vendor to determine if they can effectively meet the obligations and needs of the business regarding a service or product. ',
      gallery: [
        { src: process.env.PUBLIC_URL + '/img/for_store/catalog/assess.png' }
      ]
    }
  ]
}

module.exports.userLevel = 'admin'
module.exports.IncidentResponsePolicy = () => {
  return {
    companyName: 'Test Company',
    vendor: 'Test Vendor',

    infoSecRole: {
      title: 'Information Security Officer',
      name: 'John Doe',
      email: 'jdoe@company.com',
      telephone: '1234567890'
    },

    infoTechOfficer: {
      title: 'Information Tech Security Officer',
      name: 'Jane Doe',
      email: 'janedoe@company.com',
      telephone: '1234567890'
    },

    operationsManager: {
      roleName: 'operationsManager',
      title: 'operationsManager',
      name: 'Jane Doe',
      email: 'janedoe@company.com',
      telephone: '1234567890'
    },

    seniorManagementContact: {
      title: 'seniorManagementContact',
      name: 'Jane Doe',
      email: 'janedoe@company.com',
      telephone: '1234567890'
    },

    communicationsContact: {
      title: 'PR and Communications Director',
      name: 'Jane Doe',
      email: 'janedoe@company.com',
      telephone: '1234567890'
    },

    hrContact: {
      title: 'HR Director',
      name: 'Jane Doe',
      email: 'janedoe@company.com',
      telephone: '1234567890'
    },

    legalCounsel: {
      title: 'Legal Counsel',
      name: 'Jane Doe',
      email: 'janedoe@company.com',
      telephone: '1234567890'
    },

    otherRole: {
      roleName: 'other Role Name',
      title: 'Other Role Title',
      name: 'Jane Doe',
      email: 'janedoe@company.com',
      telephone: '1234567890'
    },

    externalContacts: {
      acquirer: {
        companyName: 'Company Acquirer',
        name: 'Acquirer Jones',
        email: 'ajones@company.com',
        telephone: '1234567890'
      },
      localLawEnforcement: {
        companyName: 'Police',
        name: 'Dectective Jones',
        email: 'police@company.com',
        telephone: '119'
      },
      fraudOrg: {
        companyName: 'Fraud',
        name: 'Fraud Officer Jones',
        email: 'fraud@company.com',
        telephone: '1800FRAUD'
      },
      otherOrg: {
        companyName: 'Other Org',
        name: 'Other Mister Jones',
        email: 'other@company.com',
        telephone: '1800OTHER'
      }
    },

    malwareResponse: 'Lorem Ipsum Protect the system Lorem Ipsum Protect the system Lorem Ipsum Protect the system',

    tamperingResponse: 'Lorem Ipsum Protect the system Lorem Ipsum Protect the system Lorem Ipsum Protect the system Lorem Ipsum Protect the system Lorem Ipsum Protect the system',

    unauthorizedAccessResponse: 'Lorem Ipsum Protect the system Lorem Ipsum Protect the system Lorem Ipsum Protect the system Lorem Ipsum Protect the system Lorem Ipsum Protect the system',

    equipmentLossResponse: 'Lorem Ipsum Protect the system Lorem Ipsum Protect the system Lorem Ipsum Protect the system Lorem Ipsum Protect the system Lorem Ipsum Protect the system',

    nonComplianceResponse: 'Lorem Ipsum Protect the system Lorem Ipsum Protect the system Lorem Ipsum Protect the system Lorem Ipsum Protect the system Lorem Ipsum Protect the system',

    testingAndUpdatesResponse: 'Lorem Ipsum Protect the system Lorem Ipsum Protect the system Lorem Ipsum Protect the system Lorem Ipsum Protect the system Lorem Ipsum Protect the system'
  }
}

module.exports.plans = [
  {
    src: process.env.PUBLIC_URL + '/img/pricing_cards/004-paper-plane.svg',
    outline: 'pricing-card pricing-card--primary',
    name: 'Basic',
    price: 8,
    features: ['Daily Updates', 'Compliance Management Module', 'Assessments Module', 'Security Playbook'],
    stripePlanId: 'plan_DSvWB4NmA5C3V2'
  },
  {

    src: process.env.PUBLIC_URL + '/img/pricing_cards/001-rocket.svg',
    outline: 'pricing-card pricing-card--danger',
    name: 'Enterprise',
    price: 20,
    features: ['Daily Updates', 'Compliance Management Module', 'Assessments Module', 'Security Playbook', 'Phone/Email Support'],
    stripePlanId: ''
  }
]

module.exports.ThirdPartyPolicy = () => {
  return {
    companyName: 'Test Company',
    vendor: 'Test Vendor',

    definitions: 'Consider whether the definitions in your Agreement need to be updated to reflect the revised definitions in the GDPR (e.g., definition of “sensitive personal data”).',

    processingDuration: '2 years',

    servicesVendorProvides: 'Specfic Detailed services that vendor will provide. data transfer, update, delete,Specfic Detailed services that vendor will provide. data transfer, update, delete,Specfic Detailed services that vendor will provide. data transfer, update, delete',

    detailedServiceDescription: 'Detailed Service Description Detailed Service DescriptionDetailed Service Description Detailed Service Description Detailed Service Description Detailed Service Description',

    dataSubjects: 'data subject 1, data subject 2, data subject 3, data subject 4, data subject 5, data subject 6, data subject 7, data subject 8',

    dataCategories: 'personal, exclusive, other categories, other categories, other categories',

    specialDataCategories: 'special personal, special exclusive, special other categories, other categories, other categories',

    processingPurpose: 'The purpose of processing is to Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',

    processingActivities: '1. Lorem ipsum dolor sit amet, consectetur adipiscing elit 2. Lorem ipsum dolor sit amet, consectetur adipiscing elit 3. Lorem ipsum dolor sit amet, consectetur adipiscing elit 4. Lorem ipsum dolor sit amet, consectetur adipiscing elit 5. Lorem ipsum dolor sit amet, consectetur adipiscing elit',

    dataSecurityTechnicalMeasures: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore',

    dataProtectionOfficerRoles: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',

    privacyShieldClause: 'If you are Privacy Shield certified, evaluate the agreement to ensure it is compliant with the Privacy Shield onward transfer requirements. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?',

    contractEndDate: '08/09/2024'

  }
}
module.exports.userLevel = 'admin'
module.exports.devPlans = [
  {
    src: process.env.PUBLIC_URL + '/img/pricing_cards/004-paper-plane.svg',
    outline: 'pricing-card pricing-card--primary',
    name: 'Basic',
    price: 8,
    features: ['Daily Updates', 'Compliance Management Module', 'Assessments Module', 'Security Playbook'],
    stripePlanId: 'plan_DSvWB4NmA5C3V2'
  },
  {

    src: process.env.PUBLIC_URL + '/img/pricing_cards/001-rocket.svg',
    outline: 'pricing-card pricing-card--danger',
    name: 'Enterprise',
    price: 20,
    features: ['Daily Updates', 'Compliance Management Module', 'Assessments Module', 'Security Playbook', 'Phone/Email Support'],
    stripePlanId: ''
  }
]

module.exports.prodPlans = [
  {
    src: process.env.PUBLIC_URL + '/img/pricing_cards/004-paper-plane.svg',
    outline: 'pricing-card pricing-card--primary',
    name: 'Basic',
    price: 8,
    features: ['Daily Updates', 'Compliance Management Module', 'Assessments Module', 'Security Playbook'],
    stripePlanId: 'plan_DYsvueIcrT7ycT'
  },
  {

    src: process.env.PUBLIC_URL + '/img/pricing_cards/001-rocket.svg',
    outline: 'pricing-card pricing-card--danger',
    name: 'Enterprise',
    price: 20,
    features: ['Daily Updates', 'Compliance Management Module', 'Assessments Module', 'Security Playbook', 'Phone/Email Support'],
    stripePlanId: ''
  }
]

module.exports.frameworksToggle = [
  {
    label: 'ISO 210007',
    toggle: ''
  },
  {
    label: 'HIPAA',
    toggle: ''
  },
  {
    label: 'GDPR',
    toggle: ''
  }
]
module.exports.commentsData = () =>
  [
    {
      id: '42',
      type: 'addComment',
      data: [{
        author: 'Sheyinka Harry',
        date: 'a few seconds ago',
        comment: 'This is a test comment'
      }]
    },
    {
      id: '43',
      type: 'addFile',
      data: [{
        author: 'Gavin Samuels',
        date: '5 mins ago',
        fileName: 'sumn.text',
        filePath: '#'

      }]
    }
  ]



// WEBPACK FOOTER //
// ./src/utils/mockData.js